var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feedback-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64,16c0,-8.831 -7.169,-16 -16,-16l-32,0c-8.831,0 -16,7.169 -16,16l0,32c0,8.831 7.169,16 16,16l32,0c8.831,0 16,-7.169 16,-16l0,-32Z",
    style: {
      fill: "url(#feedback-icon-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shadow",
    d: "M17.05,49.059l0,5.19c0,0.482 0.291,0.917 0.737,1.101c0.445,0.185 0.958,0.082 1.299,-0.259l6.017,-6.032l25.297,0c1.22,0 2.39,-0.484 3.253,-1.347c0.862,-0.863 1.347,-2.033 1.347,-3.253c-0,-6.603 -0,-18.697 -0,-25.3c0,-1.22 -0.485,-2.39 -1.347,-3.252c-0.863,-0.863 -2.033,-1.348 -3.253,-1.348c-8.814,0 -27.986,0 -36.8,0c-1.22,0 -2.39,0.485 -3.253,1.348c-0.862,0.862 -1.347,2.032 -1.347,3.252c0,6.603 0,18.697 0,25.3c-0,1.22 0.485,2.39 1.347,3.253c0.863,0.863 2.033,1.347 3.253,1.347l3.45,0Zm24.938,-7.475c0.942,-0.012 1.703,-0.78 1.703,-1.725c-0,0 -0,-9.2 -0,-9.2c-0,-0.952 -0.773,-1.725 -1.725,-1.725l-2.3,0c-0.952,0 -1.725,0.773 -1.725,1.725l-0,9.2c-0,0.952 0.773,1.725 1.725,1.725l2.3,0l0.022,0Zm-10.372,-18.975l-0,-0.575c-1.068,0 -2.091,0.424 -2.846,1.179c-0.755,0.755 -1.179,1.779 -1.179,2.846l-0,2.875l-3.212,0c-1.22,0 -2.375,0.547 -3.148,1.49c-0.772,0.943 -1.082,2.182 -0.843,3.378c0.304,1.521 0.64,3.201 0.914,4.568c0.374,1.869 2.014,3.214 3.92,3.214c1.802,0 4.092,0 5.673,0c1.301,0 2.593,-0.209 3.827,-0.621c0.846,-0.282 1.676,-0.558 1.676,-0.558c0.235,-0.079 0.393,-0.298 0.393,-0.546l-0,-9.187c0,-0.156 -0.062,-0.306 -0.172,-0.416c-0.111,-0.11 -0.261,-0.172 -0.417,-0.172c0.001,0 -0.018,0 -0.018,0c-1.57,0 -2.843,-1.273 -2.843,-2.843c-0,-1.245 -0,-2.569 -0,-3.482c-0,-0.457 -0.182,-0.896 -0.505,-1.22c-0.324,-0.323 -0.763,-0.505 -1.22,-0.505l-0,0.575Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "feedback-icon-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64,64,-34,64,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbe9b7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fce1cc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f69c460994b64f2e1f259d2a197de6d7.svg";
export { ForwardRef as ReactComponent };